(() => {
  'use strict';

  const root = window.Shopify?.routes?.root || '/';
  const cartUrl = `${root}cart.js`;
  const addUrl = `${root}cart/add.js`;
  const changeUrl = `${root}cart/change.js`;
  const favoritesKey = 'universparfum_favorites';

  const toast = (message) => {
    const el = document.getElementById('ThemeToast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    window.clearTimeout(el._timer);
    el._timer = window.setTimeout(() => el.classList.remove('is-visible'), 3200);
  };

  const setCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
    document.querySelectorAll('[data-cart-link]').forEach((el) => {
      el.setAttribute('aria-label', `Panier, ${count} article${count !== 1 ? 's' : ''}`);
    });
  };

  const refreshCartCount = async () => {
    try {
      const cart = await fetch(cartUrl, { headers: { Accept: 'application/json' } }).then((response) => response.json());
      setCartCount(cart.item_count || 0);
    } catch (_) { /* The standard cart page remains available if this request fails. */ }
  };

  const getFavorites = () => {
    try { return JSON.parse(localStorage.getItem(favoritesKey) || '[]'); } catch (_) { return []; }
  };

  const setFavorites = (favorites) => {
    localStorage.setItem(favoritesKey, JSON.stringify(favorites));
    document.querySelectorAll('[data-favorite-button]').forEach((button) => {
      const active = favorites.includes(button.dataset.productHandle);
      button.classList.toggle('is-favorite', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', `${active ? 'Retirer' : 'Ajouter'} ${button.dataset.productHandle || ''} ${active ? 'des' : 'aux'} favoris`);
    });
  };

  const setupQuantityControls = () => {
    document.querySelectorAll('[data-quantity-minus]').forEach((button) => button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('[data-quantity-input]');
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    document.querySelectorAll('[data-quantity-plus]').forEach((button) => button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('[data-quantity-input]');
      input.value = Number(input.value || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
  };

  const setupCartQuantityControls = () => {
    document.querySelectorAll('[data-cart-quantity-minus], [data-cart-quantity-plus]').forEach((button) => {
      button.addEventListener('click', async () => {
        const input = button.parentElement.querySelector('[data-cart-quantity-input]');
        const line = input?.dataset.line;
        if (!input || !line) return;
        const next = button.hasAttribute('data-cart-quantity-minus') ? Math.max(0, Number(input.value) - 1) : Number(input.value) + 1;
        input.value = next;
        try {
          await fetch(changeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: next }) });
          window.location.reload();
        } catch (_) { toast('Impossible de mettre à jour le panier.'); }
      });
    });
  };

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EUR';
    return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency }).format(cents / 100);
  };

  const setupProductVariant = () => {
    const rootEl = document.querySelector('[data-product-root]');
    const dataEl = document.querySelector('[data-product-json]');
    const select = rootEl?.querySelector('[data-variant-select]');
    if (!rootEl || !dataEl || !select) return;
    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (_) { return; }
    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === select.value);
      if (!variant) return;
      const price = rootEl.querySelector('[data-product-price]');
      if (price) {
        price.innerHTML = `<div class="price${variant.compare_at_price > variant.price ? ' price--sale' : ''}"><span class="price__current">${formatMoney(variant.price)}</span>${variant.compare_at_price > variant.price ? `<s class="price__compare">${formatMoney(variant.compare_at_price)}</s>` : ''}</div>`;
      }
      const submit = rootEl.querySelector('[data-add-to-cart]');
      if (submit) {
        submit.disabled = !variant.available;
        const label = submit.querySelector('span');
        if (label) label.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
      }
      if (variant.featured_media?.preview_image?.src) {
        const image = rootEl.querySelector('[data-main-product-image]');
        if (image) image.src = variant.featured_media.preview_image.src;
      }
    });
  };

  const closeFilters = () => {
    document.querySelector('[data-filter-panel]')?.classList.remove('is-open');
    document.body.classList.remove('filters-open');
  };

  document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('[data-site-header]');
    const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 20);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    const searchDrawer = document.querySelector('[data-search-drawer]');
    document.querySelectorAll('[data-search-toggle]').forEach((button) => button.addEventListener('click', () => {
      const willOpen = searchDrawer.hidden;
      searchDrawer.hidden = !willOpen;
      button.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) searchDrawer.querySelector('[data-search-input]')?.focus();
    }));
    document.querySelectorAll('[data-search-close]').forEach((button) => button.addEventListener('click', () => {
      searchDrawer.hidden = true;
      document.querySelector('[data-search-toggle]')?.setAttribute('aria-expanded', 'false');
    }));

    const mobileMenu = document.querySelector('[data-mobile-nav]');
    document.querySelectorAll('[data-menu-toggle]').forEach((button) => button.addEventListener('click', () => {
      mobileMenu.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      document.body.classList.add('menu-open');
    }));
    document.querySelectorAll('[data-menu-close]').forEach((button) => button.addEventListener('click', () => {
      mobileMenu.hidden = true;
      document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    }));

    document.querySelectorAll('[data-filter-toggle]').forEach((button) => button.addEventListener('click', () => {
      document.querySelector('[data-filter-panel]')?.classList.add('is-open');
      document.body.classList.add('filters-open');
    }));
    document.querySelectorAll('[data-filter-close]').forEach((button) => button.addEventListener('click', closeFilters));
    document.querySelectorAll('[data-clear-filters]').forEach((button) => button.addEventListener('click', () => { window.location.assign(button.closest('form').action); }));
    document.querySelectorAll('[data-sort-select]').forEach((select) => select.addEventListener('change', () => document.getElementById(select.getAttribute('form'))?.submit()));

    document.querySelectorAll('[data-expandable-toggle]').forEach((button) => button.addEventListener('click', () => {
      const content = button.parentElement.querySelector('[data-expandable-content]');
      const expanded = content.classList.toggle('is-expanded');
      button.querySelector('span').textContent = expanded ? 'Lire moins' : 'Lire plus';
      button.querySelector('.icon')?.classList.toggle('is-rotated', expanded);
    }));

    setFavorites(getFavorites());
    document.querySelectorAll('[data-favorite-button]').forEach((button) => button.addEventListener('click', () => {
      const favorites = getFavorites();
      const handle = button.dataset.productHandle;
      const index = favorites.indexOf(handle);
      if (index === -1) favorites.push(handle); else favorites.splice(index, 1);
      setFavorites(favorites);
      toast(index === -1 ? 'Ajouté aux favoris.' : 'Retiré des favoris.');
    }));

    document.querySelectorAll('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = true;
      try {
        const response = await fetch(addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error();
        await refreshCartCount();
        toast('Produit ajouté au panier.');
      } catch (_) { toast('Impossible d’ajouter ce produit au panier.'); }
      finally { if (submit) submit.disabled = false; }
    }));

    document.querySelectorAll('[data-media-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
      const gallery = thumb.closest('[data-product-gallery]');
      const image = gallery?.querySelector('[data-main-product-image]');
      if (image) { image.src = thumb.dataset.mediaUrl; image.alt = thumb.dataset.mediaAlt || ''; }
      gallery?.querySelectorAll('[data-media-thumb]').forEach((el) => el.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }));

    setupQuantityControls();
    setupCartQuantityControls();
    setupProductVariant();

    document.querySelector('[data-recover-toggle]')?.addEventListener('click', (event) => {
      event.preventDefault();
      document.querySelector('.recover-form')?.removeAttribute('hidden');
    });
    document.querySelector('[data-address-new]')?.addEventListener('click', () => document.querySelector('[data-address-new-form]')?.removeAttribute('hidden'));
    document.querySelectorAll('[data-address-edit]').forEach((button) => button.addEventListener('click', () => document.getElementById(`EditAddress_${button.dataset.addressEdit}`)?.removeAttribute('hidden')));
    document.querySelectorAll('[data-address-cancel]').forEach((button) => button.addEventListener('click', () => button.closest('.address-form-wrap')?.setAttribute('hidden', '')));
  });
})();
